import React from 'react'
import Head from 'next/head'
import HeroFullbleed, { BGIMAGE } from '../components/Hero/HeroFullbleed'
import Blockquote from '../components/Main/Blockquote'
import ImageCallout from '../components/Main/ImageCallout'
import CtaBanner from '../components/Main/CtaBanner'
import Page from '../components/Page'

export default function AboutUs (props) {
  const {
    //Hero Section fields
    intro_image: {
      url: introImage,
      alt: alt,
      height: height,
      width: width,
      id: imageId
    },
    intro_heading: introHeading,
    intro_paragraph: introParagraph,

    //Blockquote fields
    blockquote_quote: quote,
    blockquote_byline: byline,
    blockquote_link: { url: linkUrl, title: linkText },

    // callout_upper_images: calloutImages,
    callout_upper_images: calloutImages,
    callout_upper_heading: calloutHeading,
    callout_upper_sub_heading: calloutSubheading,
    callout_upper_paragraph: calloutParagraph,
    callout_upper_link: { url: calloutUrl, title: calloutLinkTitle },
    callout_upper_sub_text: calloutSubText,
    callout_upper_column_order: colOrder,

    //callout_about_image:
    callout_about_image: { url: aboutImageUrl },
    callout_about_image_caption: aboutCaption,
    callout_about_heading: aboutHeading,
    callout_about_sub_heading: aboutSubheading,
    callout_about_paragraph: aboutParagraph,
    callout_about_link: { url: aboutUrl, title: aboutLinkTitle },
    callout_about_column_order: aboutColOrder,
    intro_link_icon: aboutIcon,

    //callout_lower_image:
    callout_lower_image: { url: lowerImageUrl },
    callout_lower_image_caption: lowerCaption,
    callout_lower_heading: lowerHeading,
    callout_lower_sub_heading: lowerSubheading,
    callout_lower_paragraph: lowerParagraph,
    callout_lower_link: { url: lowerUrl, title: lowerLinkTitle },
    callout_lower_column_order: lowerColOrder,
    intro_link_icon: lowerIcon,

    //CtaBanner Fields
    cta_heading: ctaHeading,
    cta_link: { url: ctaLink, title: ctaButton }
  } = props.acf

  return (
    <React.Fragment>
      <Page
        title={introHeading}
        body={introParagraph}
        bgImage={introImage}
        centered
        bgId={imageId}
        alt={alt}
        height={height}
        width={width}
        slug={'/' + introHeading}
      >
        <main id='content'>
          <a id='skip' className='skip'></a>
          <Blockquote
            quote={quote}
            byline={byline}
            linkUrl={linkUrl}
            linkText={linkText}
          />
          <ImageCallout
            reversed
            array
            title={calloutHeading}
            body={calloutParagraph}
            link={calloutUrl}
            button={calloutLinkTitle}
            images={calloutImages}
          />
          <ImageCallout
            centered
            noSlug //if the link in the button goes to a page not handled by /pages/[slug].js
            title={aboutHeading}
            body={aboutParagraph}
            link={aboutUrl}
            button={aboutLinkTitle}
            image={aboutImageUrl}
          />
          <ImageCallout
            reversed
            title={lowerHeading}
            body={lowerParagraph}
            link={lowerUrl}
            button={lowerLinkTitle}
            image={lowerImageUrl}
          />
        </main>
        <CtaBanner title={ctaHeading} link={ctaLink} button={ctaButton} />
      </Page>
    </React.Fragment>
  )
}
